import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import afterCellChanged from 'pages/Valuations/approaches/backsolveApproach/BacksolveTable/util/afterCellChanged';
import parser from 'pages/Valuations/approaches/backsolveApproach/BacksolveTable/util/parser';
import reverseParser from 'pages/Valuations/approaches/backsolveApproach/BacksolveTable/util/reverseParser';
import getRowConfig from 'pages/Valuations/approaches/backsolveApproach/BacksolveTable/util/rowconfig';
import { CreateBacksolveTableData } from './types';
import conditions from './util/conditions';
import customValidations from './util/customValidations';
import totalParser from './util/totalParser';

const createBacksolveTableData = ({
  approach,
  capTableList,
  attrs,
  tableName,
  isDisabled,
}: CreateBacksolveTableData) => {
  const capTableListActual = Array.isArray(capTableList) ? capTableList : [];
  const name = tableName;
  const appliedMethodologies = approach.valuations_approach_backsolve?.applied_methodologies ?? [];

  appliedMethodologies.forEach(item => {
    // eslint-disable-next-line no-param-reassign
    item.isDeleteableColumn = appliedMethodologies.length > 1;
  });
  const getColumns = () => [[], ...appliedMethodologies];
  const columns = getColumns();
  // eslint-disable-next-line no-param-reassign
  approach.valuations_approach_backsolve.deleted_methodologies = [];

  return new SpreadsheetConfig({
    name,
    parser,
    reverseParser: reverseParser as unknown as SpreadsheetConfig['reverseParser'],
    rowConfig: getRowConfig({ captableList: capTableListActual, approach, isDisabled }),
    tableData: { approach, isDisabled },
    columns,
    showTitlesColumn: false,
    showToolbar: true,
    fieldAttributes: attrs,
    showTotalColumn: true,
    totalParser,
    conditions: conditions as unknown as SpreadsheetConfig['conditions'],
    customValidations: customValidations as unknown as SpreadsheetConfig['customValidations'],
    afterCellChanged: afterCellChanged as unknown as SpreadsheetConfig['afterCellChanged'],
    allowReorderColumns: false,
    allowCopyColumn: false,
    allowDeleteOnlySpecificColumn: !isDisabled,
    getColumns,
    showPreviousColsDivider: false,
    unitsFormatter: false,
    currencyFormatter: false,
    format: undefined,
  });
};

export default createBacksolveTableData;
